<div class="action-container">
    <ng-content></ng-content>
    <ham-button
        [disabled]="isSaveDisabled"
        [outline]="true"
        size="sm"
        icon="assets/hamIcons/floppy.svg"
        (buttonClick)="onSave()"
    >
        {{ saveText }}
    </ham-button>
    <ham-button
        [disabled]="isSaveAndProceedDisabled"
        size="sm"
        icon="assets/hamIcons/floppy.svg"
        (buttonClick)="onSaveAndProceed()"
    >
        {{ saveAndProceedText }}
    </ham-button>
</div>
